import { RadioGroupItem } from '@/shared/ui/radio-group'

interface TicketTypeOptionProps {
  value: 'free' | 'paid'
  label: string
  description?: string
}

export function TicketTypeOption({ value, label, description }: TicketTypeOptionProps) {
  return (
    <label
      htmlFor={`type-${value}`}
      className="flex cursor-pointer items-start gap-3 rounded-xl border border-zinc-200 bg-white p-4 transition-colors hover:border-zinc-300 hover:bg-zinc-50/60 has-[[data-state=checked]]:border-blue-600 has-[[data-state=checked]]:bg-blue-50/40 has-[[data-state=checked]]:ring-1 has-[[data-state=checked]]:ring-blue-600"
    >
      <RadioGroupItem value={value} id={`type-${value}`} className="mt-0.5" />
      <div className="flex-1">
        <span className="block text-sm font-semibold text-zinc-900">{label}</span>
        {description && <span className="block text-xs text-zinc-500 mt-0.5">{description}</span>}
      </div>
    </label>
  )
}
